export const messages = {
  en: {
    staffFeeManage: {
      search: {
        title: 'Search Conditions',
        userCode: 'Staff Code',
        userCodePlaceholder: 'Please enter staff code',
        startTime: 'Start Time',
        startTimePlaceholder: 'Please select start time',
        endTime: 'End Time',
        endTimePlaceholder: 'Please select end time'
      },
      list: {
        title: 'Staff Fee Management'
      },
      table: {
        userCode: 'Staff Code',
        userName: 'Staff Name',
        receivableAmount: 'Receivable Amount',
        receivedAmount: 'Received Amount',
        yuan: 'Yuan'
      },
      fetchError: 'Failed to fetch staff fee data',
      page: {
        title: 'Staff Fee Management',
        subtitle: 'Review receivable and received amounts collected by staff',
        empty: 'No staff fee records found',
        loadFailed: 'Failed to load staff fee data, please retry',
        tip: 'Amounts are aggregated within the selected time range.'
      }
    }
  },
  zh: {
    staffFeeManage: {
      search: {
        title: '查询条件',
        userCode: '员工编码',
        userCodePlaceholder: '请填写员工编码',
        startTime: '开始时间',
        startTimePlaceholder: '请选择开始时间',
        endTime: '结束时间',
        endTimePlaceholder: '请选择结束时间'
      },
      list: {
        title: '员工收费管理'
      },
      table: {
        userCode: '员工编码',
        userName: '员工名称',
        receivableAmount: '应收金额',
        receivedAmount: '实收金额',
        yuan: '元'
      },
      fetchError: '获取员工收费数据失败',
      page: {
        title: '员工收费管理',
        subtitle: '查看员工的应收与实收金额',
        empty: '暂无员工收费记录',
        loadFailed: '员工收费数据加载失败，请重试',
        tip: '金额按所选时间范围汇总统计。'
      }
    }
  }
}